var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00745 0.525635H7.00745H17.0074H17.4217L17.7146 0.818528L21.7146 4.81853L22.0074 5.11142V5.52563V18.5256V19.5256H21.0074H19.0074V17.5256H20.0074V6.52563H18.0074H17.5932L17.3003 6.23274L16.3003 5.23274L16.0074 4.93985V4.52563V2.52563H8.00745V3.55688H6.00745V1.52563V0.525635ZM18.0074 3.93985L18.5932 4.52563H18.4217L18.0074 4.11142V3.93985ZM2.00745 4.52563H3.00745H13.0074H13.4239L13.7173 4.82128L17.7173 8.85254L18.0074 9.14495V9.55688V22.5256V23.5256H17.0074H3.00745H2.00745V22.5256V5.52563V4.52563ZM4.00745 6.52563V21.5256H16.0074V10.5569H13.0074H12.0074V9.55688V6.52563H4.00745ZM14.0074 7.9532L14.6065 8.55688H14.0074V7.9532ZM6.00745 8.52563V10.5256H10.0074V8.52563H6.00745ZM14.0074 13.5256V11.5256H6.00745V13.5256H14.0074ZM14.0074 16.5256V14.5256H6.00745V16.5256H14.0074ZM6.00745 19.5256H11.0074V17.5256H6.00745V19.5256Z",
    fill: "#ff5f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments24);
export default __webpack_public_path__ + "static/media/documents_24.627214c447578ab0813569a3b04442a2.svg";
export { ForwardRef as ReactComponent };